require(['jquery'], function($) {

	$('.accordion-button').on('click', function(e) {
		e.preventDefault();

		$('.accordion').removeClass('open');
		$('.accordion-content').each(function () {
			$(this).slideUp(400);
		});

		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			// setTimeout(function() {
			// 	$('html, body').animate({
			// 		scrollTop: $('.section-JobsAccordion').offset().top
			// 	}, 200);
			// }, 400);
		} else {
			$('.accordion-button').removeClass('active');
			$(this).parent().addClass('open');
			$(this).next().slideDown(400);
			$(this).addClass('active');

			var $this = $(this).closest('.accordion');

			setTimeout(function() {
				$('html, body').animate({
					scrollTop: $this.offset().top
				}, 200);
			}, 400);
		}
	});

	$('.accordion-close').on('click', function(e) {
		e.preventDefault();
		$('.accordion').removeClass('open');
		$(this).parent().slideUp(400);
		$(this).parent().prev().removeClass('active');
	});

});
define("root/Assets/Templates/Html/JobsAccordion/Js/JobsAccordion", function(){});

